<template>
	<div class="news">
		<!-- <div class="news-title" @click="col = 2">
			{{$t('品牌新闻')}}
		</div> -->
		<div class="news-title u-flex-col u-col-center u-row-center">
			<video class="index-video" id="video-new"  @loadeddata="setVideoPoster($event)" v-if="data.type == 'mp4'" :src="data.cover" muted :autoplay="true" loop :controls="false" :webkit-playsinline="true" playsinline :x5-playsinline="true" 
			:x-webkit-airplay="true"  preload="auto" x5-video-player-type="h5" :x5-video-player-fullscreen="true" crossorigin="anymous" type="video"></video>
			<img :src="data.cover" class="index-video" alt="" v-if="data.type == 'img'">
			<span class="span1 fadeInUp animated" v-if="$locale == 'zh'">{{data.name}}</span>
			<span class="span1 fadeInUp animated" v-if="$locale == 'en'">{{data.nameEnglish}}</span>
			<!-- <span class="span2" v-if="$locale == 'zh'">{{data.des}}</span>
			<span class="span2" v-if="$locale == 'en'">{{data.desEnglish}}</span> -->
		</div>
		<div class="news-content">
			<div class="news-lable u-flex u-col-center u-flex-wrap">
				<div :class="active == -1 ? 'label-item label-item1' : 'label-item'" @click="changelabel(-1)">
					<span>{{$t('全部')}}</span>
					<img src="../assets/imgs/news1-1.png" alt="">
				</div>
				<div :class="active == index ? 'label-item label-item1' : 'label-item'" v-for="(item,index) in labellist" :key="index" @click="changelabel(index)">
					<span v-if="$locale == 'zh'">{{item.name}}</span>
					<span v-if="$locale == 'en'">{{item.nameEnglish}}</span>
					<span v-if="$locale == 'de'">{{item.nameGerman}}</span>
					<img src="../assets/imgs/news1-1.png" alt="">
				</div>
			</div>
			<div class="news-list">
				<div class="waterfallFlowBOx box u-flex u-col-top">
					<div class="img_item fadeInUp animated" v-for="(item,index) in list" :key="index" @click="toinfo(item,index)">
						<!-- <img src="https://dummyimage.com/340x220/e3e3e3/fff" alt=""> -->
						<div class="u-flex u-col-center u-row-center">
							<img :src="$http.url + '/sys/common/static/' + item.pic" loading="lazy" alt="">
						</div>
						<div class="item-title u-flex u-col-center u-row-between">
							<span v-if="$locale == 'zh'">{{item.title}}</span>
							<span v-if="$locale == 'en'">{{item.titleEnglish}}</span>
							<span v-if="$locale == 'de'">{{item.titleGerman}}</span>
							<span>{{item.createTime.substring(0, item.createTime.length - 3)}}</span>
						</div>
						<div>
							<div class="item-desc text_hide3" style="-webkit-box-orient: vertical;" v-if="$locale == 'zh'">{{item.des}}</div>
							<div class="item-desc text_hide3" style="-webkit-box-orient: vertical;" v-if="$locale == 'en'">{{item.desEnglish}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="page u-flex u-col-center u-row-center">
				<el-pagination background layout="prev, pager, next" :current-page="page" :prev-text="$t('上一页')" :next-text="$t('下一页')" :page-size="pageSize" :total="total" :hide-on-single-page="true" @current-change="currentpage"></el-pagination>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: -1,
				labellist: [],
				list: [],
				data: {},
				col: 4,
				clientWidth: 0,
				page: 1,
				pageSize: 12,
				total: 0
			}
		},
		created() {
			this.getlable()
			this.getdata()
			this.getlist()
			this.$parent.settitle(this.$t('品牌新闻'))
		},
		mounted() {
			window.addEventListener('touchstart',function(){
				if(	document.getElementById('video-new')) {
					document.getElementById('video-new').play()
					console.log('开始播放');

				}
			})
		},
		computed: {

		},
		methods: {
			setVideoPoster(event) {
				let video = event.target;
				// video.height = video.clientHeight;
				let canvas = document.createElement("canvas"); // 创建 canvas
				const ctx = canvas.getContext("2d");
				video.currentTime = 1; // 第一帧
				video.oncanplay = () => {
					canvas.width = video.clientWidth; // 获取视频宽度
					canvas.height = video.clientHeight; //获取视频高度
					var img = new Image(); // 这里使用img是为了解决视频跨域 canvas.toDataURL会提示错误的问题
					img.onload = function () {
						// canvas绘图
						ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
						// 转换成base64形式并设置封面
						video.poster = canvas.toDataURL("image/jpeg", 1); // 截取后的视频封面
					}
				}
			},
			getdata() {
				this.$http.post('/api/Index/getNewsHeadAssets').then((res) => {
					this.data = res.result
					if(this.data.cover.substr(this.data.cover.length - 3) == 'mp4') {
						this.data.type = 'mp4'
					} else {
						this.data.type = 'img'
					}
				})
			},
			currentpage(e) {
				this.list = []
				this.page = e
				this.getlist()
			},
			scroll(scrollData) {
			},
			switchCol(col) {
				this.col = col
			},
			loadmore(index) {
				this.data = this.data.concat(this.data)
			},
			changelabel(active) {
				this.page = 1
				this.list = []
				this.active = active
				this.getlist()
			},
			getlist() {
				this.$http.post('/api/Index/getNewsPageList', {
					typeId: this.active == -1 ? '' : this.labellist[this.active].id,
					pageNo: this.page,
					pageSize: this.pageSize,
				}, true).then(res => {
					this.list = res.result.records
					this.total = res.result.total
					setTimeout(() => {
						this.waterfallFlow()
						window.onresize = () => {
							this.waterfallFlow()
						}
					}, 200)
				})
			},
			getlable() {
				this.$http.post('/api/Index/getNewsfl').then(res => {
					this.labellist = res.result
				})
			},
			toinfo(item,index) {
				window.localStorage.newlist = JSON.stringify(this.list)
				window.localStorage.newindex = index
				this.$router.push({
					path: "/news-info",
					query: {
						id: item.id
					}
				})
			},
			waterfallFlow() {
				var value = $(".waterfallFlowBOx").outerWidth(); //获取父级的宽度
				this.clientWidth = value
				if (value > 1125 && value < 1500) {
					this.col = 4
				} else if (value <= 1125 && value > 750) {
					this.col = 3
				} else if (value <= 750) {
					this.col = 2
				}
			},
		}
	}
</script>

<style lang="scss">
.el-pagination.is-background .el-pager li:not(.disabled).active {
	background: #BF262A;
}
.fadeInUp {
		-webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
		visibility: visible;
	}
	.animated {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
	}
	@keyframes fadeInUp {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0,100%,0);
			transform: translate3d(0,100%,0);
		}
		100% {
			opacity: 1;
			-webkit-transform: none;
			transform: none;
		}
	}
</style>
